import { CheckoutStep } from '../../types/checkouts';
import useCheckoutFormState from './useCheckoutFormState';

/** Which half of the checkout the user is on. */
export default function useCheckoutStep() {
  const { state, dispatch } = useCheckoutFormState();

  return {
    step: state.step,
    setStep: (step: CheckoutStep) =>
      dispatch({ type: 'SET_STEP', payload: step }),
  };
}
